import { Device } from "./utils";
export function getDeviceType(win: Window): Device {
  // @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent

  let hasTouchScreen = false;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  const UA = win.navigator.userAgent;

  if ("maxTouchPoints" in win.navigator) {
    hasTouchScreen = win.navigator.maxTouchPoints > 0;
  } else if ("msMaxTouchPoints" in win.navigator) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    hasTouchScreen = win.navigator.msMaxTouchPoints > 0;
  } else {
    const mQ = win.matchMedia && matchMedia("(pointer:coarse)");
    if (mQ && mQ.media === "(pointer:coarse)") {
      hasTouchScreen = !!mQ.matches;
    } else if ("orientation" in win) {
      hasTouchScreen = true; // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing

      hasTouchScreen =
        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
        /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
    }
  }

  const isTablet = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(UA);
  const isMacOS = /Macintosh/i.test(UA);

  // need to revisit this condition
  if (hasTouchScreen && isTablet) {
    return Device.TABLET;
  } else if ((hasTouchScreen && isMacOS) || (!hasTouchScreen && !isTablet)) {
    return Device.DESKTOP;
  } else {
    return Device.MOBILE;
  }
}

export function isIOSDevice(win: Window): boolean {
  return /iPad|iPhone|iPod/.test(win.navigator.userAgent) && !window.MSStream;
}

export function isSafariBrowser(win: Window): boolean {
  return !!win.navigator.userAgent.match(/Version\/[\d]+.*Safari/);
}
